import React from "react";
import styled from "styled-components";
import { AppColors } from "../../config/AppColors";
import { AppFonts } from "../../config/AppFonts";
import AppLoader from "../loader/AppLoader";

const Button = styled.button`
  outline: none;
  border: none;
  background-color: ${AppColors.Pinkish};
  height: 3rem;
  font-family: ${AppFonts.regular};

  color: ${AppColors.WHITE};
  border-radius: 3.5rem;
  cursor: pointer;
  margin: 0 auto;

  &:focus {
    outline: none;
    border: none;
  }
`;

function DefaultButton({ children, onClick, isloading, size }) {
  return (
    <Button
      onClick={onClick}
      style={{ width: size === "half" ? "8rem" : "10rem" }}
    >
      {isloading ? <AppLoader /> : children}
    </Button>
  );
}

export default DefaultButton;
